import $ from 'jquery';
const ninjaforms = () => {
    $(document).ready(function() {
        const debug_logs = false;
        if (debug_logs) console.log('~~~ UTM Juggler Loaded – 1.0.4 ~~~');

        var utmParams = getUTMParams() || getUTMParamsFromCookies();

        // Function to get UTM parameters from the URL
        function getUTMParams() {
            var params = {};
            var queryString = window.location.search.substring(1);
            var regex = /([^&=]+)=([^&]*)/g;
            var match;

            while (match = regex.exec(queryString)) {
                let key = decodeURIComponent(match[1]);
                if (key.startsWith('utm_')) {
                    params[key] = decodeURIComponent(match[2]);
                }
            }

            if (Object.keys(params).length > 0) {
                if (debug_logs) console.warn('Found the following UTM parameters from URL:', params);
                return params;
            }
            return null;
        }

        // Function to get UTM parameters from cookies
        function getUTMParamsFromCookies() {
            var params = {};
            var cookies = document.cookie.split(';');
            cookies.forEach(function(cookie) {
                var parts = cookie.split('=');
                var key = parts[0].trim();
                var value = parts[1] ? decodeURIComponent(parts[1].trim()) : '';

                if (key.startsWith('utm_')) {
                    params[key] = value;
                }
            });

            if (Object.keys(params).length > 0) {
                if (debug_logs) console.warn('Found the following UTM parameters from cookies:', params);
                return params;
            }
            return null;
        }

        // Function to update UTM parameter values based on class names
        function updateUTMParamValues() {
            var utmClasses = {
                'user-analytics-utm-source-wrap':   'utm_source',
                'user-analytics-utm-medium-wrap':   'utm_medium',
                'user-analytics-utm-campaign-wrap': 'utm_campaign',
                'user-analytics-utm-term-wrap':     'utm_term',
                'user-analytics-utm-content-wrap':  'utm_content'
            };

            for (var utmClass in utmClasses) {
                if (utmClasses.hasOwnProperty(utmClass)) {
                    var utmParamKey = utmClasses[utmClass];
                    var utmElements = document.querySelectorAll(`.${utmClass}`);

                    utmElements.forEach(function(utmElement) {
                        var input = utmElement.querySelector('input');

                        if (input && utmParams[utmParamKey]) {
                            if (debug_logs) console.warn(`Found hidden input for: ${utmClass}`);
                            if (debug_logs) console.log('╚══ Original value: ' + input.value);
                            input.value = utmParams[utmParamKey];
                            if (debug_logs) console.log(`╚══ Updated input value for ${utmParamKey}: ${input.value}`);
                            $(input).trigger('change');  // Ensure Backbone model is updated
                            if (debug_logs) console.log(`╚══ Trigger change the hidden value: ${input.value}`);
                        }
                    });
                }
            }
        }

        // Function to handle updating the values within Marionette => Backbone
        function updateMarionetteBackboneJS() {
            if (typeof Backbone !== 'undefined') {
                if (debug_logs) console.warn('Found Backbone.js');
                if (typeof Marionette !== 'undefined') {
                    if (debug_logs) console.warn('Found Marionette.js');
                    var form12nfController = Marionette.Object.extend({
                        initialize: function() {
                            if (debug_logs) console.warn('Marionette::initialize() executed');
                            var nfFieldContainers = [
                                '#nf-field-251-container',
                                '#nf-field-252-container',
                                '#nf-field-253-container',
                                '#nf-field-254-container',
                                '#nf-field-255-container'
                            ];

                            nfFieldContainers.forEach(function(selector) {
                                var input = jQuery(selector).find('input');
                                var input_val = input.val();

                                if (input.length) {
                                    if (debug_logs) console.log('╚══ utm input val change triggered for', selector, 'to use', input_val);

                                    input.val(input_val).trigger('change');
                                }
                            });

                            // @TODO: you can get the form-{id} dynamically
                            this.listenTo(nfRadio.channel('form-12'), 'before:submit', this.actionSubmit);
                        },
                        actionSubmit: function(view) {
                            if (debug_logs) console.warn('Marionette::actionSubmit()');

                            // Debugging the structure of view
                            if (debug_logs) console.log('view:', view);

                            try {
                                var fields = view.attributes.fields;
                                if (debug_logs) console.log('fields:', fields);
                            } catch (error) {
                                if (debug_logs) console.error('Error accessing fields:', error);
                                return; // Exit the function if an error occurs
                            }

                            if (debug_logs) console.log('╚══ Current fields values:', JSON.stringify(fields));
                        }
                    });

                    // Execute the new controller
                    new form12nfController();
                } else {
                    if (debug_logs) console.error('Unable to find Marionette');
                }
            } else {
                if (debug_logs) console.error('Unable to find Backbone');
            }
        }

        if (utmParams) {
            // Execute the UTM parameter value updater
            updateUTMParamValues();

            // Check for the presence of Ninja Forms before executing the Marionette form submit attacher
            if ($('.nf-form-cont').length > 0) {
                updateMarionetteBackboneJS();
            } else {
                if (debug_logs) console.log('Ninja Forms not present on the page.');
            }
        } else {
            if (debug_logs) console.log('No UTM query vars or cookies present for capture in Ninja form instance');
        }
    });
}

export default ninjaforms;

